import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import articleImg from "../../assets/article4.jpg"
import ArticleContent from "../../components/sections/blog/ArticleContent";
import { articleContent4 } from "../../constants/data";
import RequestDemo from "../../components/common/RequestDemo";

const ArticleFourth = ({title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-[2.25rem] sm:gap-16 lg:gap-0">
      <HeroReuse
        Title="The Startup Rollercoaster: Behind the scenes of starting RegTechFlow"
        Description="Regulatory complexity is growing, and manual compliance processes can’t keep up."
        date="6 June 2025"
        imgUrl={articleImg}
        titleClass={'tracking-tight pt-3 md:pt-8'}
      />
      <ArticleContent content={articleContent4} toolsClass="font-bold text-darkGray"/>
      <RequestDemo />
    </div>
  );
};

export default ArticleFourth;
